import { render, staticRenderFns } from "./emperor.vue?vue&type=template&id=5a32974a&"
import script from "./emperor.vue?vue&type=script&lang=js&"
export * from "./emperor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a32974a')) {
      api.createRecord('5a32974a', component.options)
    } else {
      api.reload('5a32974a', component.options)
    }
    module.hot.accept("./emperor.vue?vue&type=template&id=5a32974a&", function () {
      api.rerender('5a32974a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/emperor/emperor.vue"
export default component.exports